import { makeStyles } from "@material-ui/core"

export const Styles = makeStyles({
  centerStyle: {
    textAlign: "center",
  },
})
